// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"368":"confirm","845":"profile","953":"foods"}[chunkId] + "." + {"368":"2f3ee68b","845":"68ee05f0","953":"cfc2a976"}[chunkId] + ".css";
};